'use client';

import { FC } from 'react';
import {
  FlipCard,
  FlipCardBack,
  FlipCardFront,
  FlipCardTurnButton,
} from '@wwe-portal/ui/components/flip-card';
import { RosterCardFrontDetail } from './roster-card/roster-card-front-detail';
import { RosterCardBackDetail } from './roster-card/roster-card-back-detail';
import { TierLevelEnum } from '@wwe-portal/entities/roster.type';
import { useResponsive } from '@wwe-portal/ui/hooks/use-responsive';
import { getPImageUrl } from '@wwe-portal/web/libs/p-img';

export interface RosterFlipCardProps {
  image: string;
  name: string;
  stats: {
    playStyle: string;
    classValue: {
      class: string;
      class_ID: string;
    };
    tier: string;
  };
  videoLinks?: {
    image: string;
    link: string;
  }[];
  isFlipped: boolean;
  handleFlipBack: () => void;
  handleFlipFront: () => void;
}

export const RosterFlipCard: FC<RosterFlipCardProps> = ({
  image,
  name,
  stats,
  videoLinks,
  isFlipped,
  handleFlipBack,
  handleFlipFront,
}) => {
  const { isMobile, isHydrated, isTablet } = useResponsive();
  const effectEnabled = isHydrated && !isMobile && !isTablet;
  return (
    <FlipCard className="h-full w-full" flip={isFlipped}>
      <FlipCardFront>
        <RosterCardFrontDetail
          effectEnabled={effectEnabled}
          maskImage={
            stats.tier === TierLevelEnum.SPlus
              ? getPImageUrl(image, {
                  width: 640,
                  mask: true,
                })
              : undefined
          }
          lightType={stats.tier === TierLevelEnum.SPlus ? 'rainbow' : 'white'}
          image={image ?? ''}
          name={name}
          flipButton={
            <FlipCardTurnButton
              className="rounded-full border border-white bg-[#9F211B] p-2"
              iconClassName="w-5 h-5"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleFlipBack();
              }}
            />
          }
        />
      </FlipCardFront>
      <FlipCardBack>
        <RosterCardBackDetail
          videoLinks={videoLinks}
          stats={stats ?? { classValue: {}, tier: '', playStyle: '' }}
          flipCardComponent={
            <FlipCardTurnButton
              className="rounded-full border border-white bg-[#0d0d0d] p-2"
              iconClassName="w-5 h-5"
              onClick={handleFlipFront}
            />
          }
        />
      </FlipCardBack>
    </FlipCard>
  );
};